const ArrowUpLeft01Icon = /*#__PURE__*/ [
  ["path", { d: "M15 6.65032C15 6.65032 8.06166 6.10759 7.08461 7.08463C6.10755 8.06167 6.65037 15 6.65037 15M7.5 7.5L17.5 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { ArrowUpLeft01Icon as default };
//# sourceMappingURL=ArrowUpLeft01Icon.js.map
